import { render, staticRenderFns } from "./AccommodationReviewTable.vue?vue&type=template&id=72feae1f&scoped=true&"
import script from "./AccommodationReviewTable.vue?vue&type=script&lang=js&"
export * from "./AccommodationReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72feae1f",
  null
  
)

export default component.exports